import { Component, Input, OnInit } from '@angular/core';
import { Chapter } from '../../../../models/chapter';
import { PageService } from '../../../../services/page.service';
import { ChapterService } from '../../../../services/chapter.service';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { CommunicationService } from '../../../../services/communication.service';
import { PreviewPages } from '../single-chapter-page/preview-pages';
import { MainChapterHeadingComponent } from '../../../utils/main-chapter-heading/main-chapter-heading.component';
import { SingleChapterPageComponent } from '../single-chapter-page/single-chapter-page.component';

@Component({
    selector: 'sidebar-chapter-pages',
    templateUrl: './chapter-pages.component.html',
    styleUrls: ['./chapter-pages.component.scss'],
    standalone: true,
    imports: [
        MainChapterHeadingComponent,
        SingleChapterPageComponent
    ]
})
export class ChapterPagesComponent implements OnInit {

    private static idGenerator = 0;

    @Input() chapter: Chapter;
    pagePreviews: Array<PreviewPages>;
    chapterPageNumber: number;

    constructor(private pageService: PageService,
                private chapterService: ChapterService,
                private applicationStateService: ApplicationStateService,
                private communicationService: CommunicationService) {

        this.communicationService.viewModeChangeAnnounced$.subscribe(viewModeChangedEvent => {
            this.init();
        });
    }

    ngOnInit(): void {
        this.init();
    }

    getChapterPageNumber(): void {
        this.chapterPageNumber = this.pageService.getRealPageNumber(this.chapter.index);
    }

    private init(): void {
        this.getChapterPageNumber();
        this.chapterService.getMainChapterStartAndEndIndex(this.chapter).then(indexes => {
            const pages = this.pageService.getPages(indexes[0], indexes[1]);
            this.pagePreviews = [];

            for (let positionOverall = 0;
                 positionOverall < pages.length;
                 positionOverall = positionOverall + this.applicationStateService.currentViewMode.pagesToShow
            ) {
                const currentPreview = [];
                const numInPackageOfFirstPage =
                    (pages[positionOverall].index + 1) % this.applicationStateService.currentViewMode.pagesToShow;

                // Empty element before first page of chapter
                for (let positionInCurrentPreview = 0; positionInCurrentPreview < numInPackageOfFirstPage; positionInCurrentPreview++) {
                    currentPreview.push(undefined);
                }
                // Add element at right position
                currentPreview.push(pages[positionOverall]);

                // Add following pages to preview. If the next chapter starts or there are no pages left, fill with empty values
                for (let positionInCurrentPreview = numInPackageOfFirstPage + 1;
                     positionInCurrentPreview < this.applicationStateService.currentViewMode.pagesToShow;
                     positionInCurrentPreview++
                ) {
                    if (pages[positionOverall + positionInCurrentPreview]) {
                        currentPreview.push(pages[positionOverall + positionInCurrentPreview]);
                    } else {
                        currentPreview.push(undefined);
                    }
                }

                const previewPages = new PreviewPages();
                previewPages.pages = currentPreview;
                previewPages.id = ChapterPagesComponent.idGenerator++;
                this.pagePreviews.push(previewPages);

                // Fix position
                positionOverall -= numInPackageOfFirstPage;
            }
        });
    }

}
